import { $t } from '@/i18n';
import pageLoader from '@loaders/page/loader';

export default {
  type: 'object',
  fields: [
    {
      id: 'type',
      type: 'string',
      title: $t('k_8fc3cc81'),
      enum: [
        { label: $t('k_632fca9c'), value: 'page' },
        { label: $t('k_b1b44774'), value: 'pagelet' },
        { label: $t('k_a792bd21'), value: 'flowNodePagelet' },
      ],
      default: 'page',
    },
    {
      id: 'pageId',
      type: 'string',
      title: $t('k_632fca9c'),
      ui: { type: 'XyInnerPageSelector' },
      default: '',
      condition: 'props.type === "page"',
    },
    {
      id: 'pageletId',
      type: 'string',
      title: $t('k_b1b44774'),
      ui: { type: 'XyInnerPageletSelector' },
      default: '',
      condition: 'props.type === "pagelet"',
    },
    {
      id: 'flowNodePageletConfig',
      type: 'any',
      title: $t('k_1c84afdb'),
      ui: { type: 'XyInnerFlowNodePageletConfig' },
      default: {
        flowId: '',
        nodeId: '',
      },
      condition: 'props.type === "flowNodePagelet"',
    },
    {
      id: 'params',
      type: 'array',
      title: $t('k_a2c2ad0'),
      ui: {
        type: 'XyPageletPropsEditor',
        props: {
          allowBind: true,
          async getPagelet(inputBox) {
            const { pageId, pageletId, type } = inputBox.container.stub.parent.value;
            if (type === 'page' && pageId) {
              const { projectConfig: { id: projectId } } = inputBox.wContext;  // wContext.projectId 可能是空的
              const ans = await pageLoader.getPageDetail({ projectId, pageId });
              const pageConfig = ans?.pageConfig;
              const pagelets = Array.isArray(pageConfig) ? pageConfig : [];
              return pagelets?.find(x => x.id === 'default');
            }
            if (type === 'pagelet' && pageletId) {
              const pageConfig = inputBox?.wContext?.config?.pageConfig;
              const pagelets = Array.isArray(pageConfig) ? pageConfig : [];
              return pagelets?.find(x => x.id === pageletId);
            }
          },
        },
      },
      items: {
        type: 'object',
        fields: [
          { id: 'key', type: 'string' },
          { id: 'value', type: 'string' },
          { id: 'bind', type: 'string' },
        ],
      },
    },
    {
      id: 'loadingMode',
      type: 'string',
      title: $t('k_392ee8e0'),
      description: $t('k_4351ea3'),
      enum: [
        { label: $t('k_ef5d61e6'), value: 'default' },
        { label: $t('k_5c568e48'), value: 'skeleton' },
        { label: $t('k_ba47627b'), value: 'silence' },
      ],
      default: 'default',
    },
    {
      id: 'tips',
      title: $t('k_37711124'),
      type: 'object',
      default: null,
      ui: { type: 'XyPageContainerTips' },
      'uc:allowExpr': false,
      'uc:allowReset': false,
    },
  ],
};
